var map = {
	"./Bank.svg": "c0d4",
	"./Barcode.svg": "7b69",
	"./Coin.svg": "644b",
	"./Copy.svg": "a6a6",
	"./Elipse.svg": "189d",
	"./Information.svg": "f5ea",
	"./Line.svg": "3286",
	"./Locator.svg": "92c5",
	"./Num.svg": "ebda",
	"./Order.svg": "fc36",
	"./Phone.svg": "f21e",
	"./Pricetruck.svg": "068a",
	"./Rectangle.svg": "d620",
	"./Save.svg": "6110",
	"./SaveOutline.svg": "9413",
	"./Social.svg": "ed13",
	"./Stock.svg": "97a0",
	"./Text.svg": "9f8d",
	"./Vat.svg": "81f6",
	"./assignment.svg": "54ba",
	"./bad-review.svg": "f41c",
	"./calculator.svg": "0ea2",
	"./calendar-blank.svg": "5748",
	"./calendar.svg": "51b0",
	"./calendar_outline.svg": "e956",
	"./camera.svg": "f890",
	"./cell-phone.svg": "af07",
	"./check-circle.svg": "526d",
	"./check.svg": "2a3f",
	"./cog.svg": "9fa2",
	"./csv-file-format-extension.svg": "5285",
	"./desktop-monitor.svg": "634a",
	"./discount.svg": "f2b0",
	"./document-duplicate.svg": "b88f",
	"./download.svg": "a334",
	"./drag.svg": "5f29",
	"./dragz.svg": "fcc8",
	"./edit-outline.svg": "a71e",
	"./eye-blind.svg": "2b32",
	"./eye.svg": "99fe",
	"./formula.svg": "e24a",
	"./internet.svg": "13d5d",
	"./items.svg": "bb3f",
	"./left-turn-arrow.svg": "328d",
	"./logout.svg": "5201",
	"./man.svg": "420a",
	"./microsoft-excel.svg": "3a25",
	"./note-add.svg": "f5fe",
	"./pencil-alt.svg": "024d",
	"./printOutline.svg": "cc8e",
	"./puiblish.svg": "3dee",
	"./receipt.svg": "0cde",
	"./resize-column.svg": "caaa",
	"./right-turn-arrow.svg": "769b",
	"./saveOutline2.svg": "3732",
	"./set.svg": "11ed",
	"./share.svg": "4b3f",
	"./shopping-bag.svg": "9b58",
	"./shopping_bag_2.svg": "820f",
	"./tags.svg": "a0d4",
	"./trash-outline.svg": "7ac4",
	"./trash.svg": "7c29",
	"./truck.svg": "64c4",
	"./window-list.svg": "996a",
	"./x-circle.svg": "1a16",
	"./xlsx-file-format-extension.svg": "108e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "650e";